import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, Camera, FileSignature, Truck, Calculator, Receipt } from "lucide-react";

export const ProjectTabs = ({ projectId, active }) => {
  const { user } = useAuth();
  const [counts, setCounts] = useState(null);

  useEffect(() => {
    if (!projectId) return;
    api.get(`/projects/${projectId}/tabs-summary`).then(({ data }) => setCounts(data)).catch(() => {});
  }, [projectId]);

  const role = user?.role;
  const tabs = [
    { key: "resumen", to: `/projects/${projectId}`, label: "Resumen", icon: LayoutDashboard },
    { key: "gallery", to: `/projects/${projectId}/gallery`, label: "Galería", icon: Camera, count: counts?.photos },
    { key: "contracts", to: `/projects/${projectId}/contracts`, label: "Contratos", icon: FileSignature, count: counts?.contracts, roles: ["admin", "contador", "auxiliar"] },
    { key: "machinery", to: `/projects/${projectId}/machinery`, label: "Maquinaria", icon: Truck, count: counts?.machines, roles: ["admin", "contador", "auxiliar", "residente", "supervisor"] },
    { key: "budget", to: `/projects/${projectId}/budget`, label: "Presupuesto", icon: Calculator, roles: ["admin", "contador", "supervisor", "residente", "auxiliar"] },
    { key: "expenses", to: `/projects/${projectId}/expenses`, label: "Gastos", icon: Receipt, roles: ["admin", "contador", "supervisor", "residente"] },
  ].filter((t) => !t.roles || role === "admin" || t.roles.includes(role));

  return (
    <div className="flex gap-1.5 flex-wrap" data-testid="project-tabs">
      {tabs.map(({ key, to, label, icon: Icon, count }) => (
        <Link key={key} to={to} data-testid={`project-tab-${key}`}
          className="flex items-center gap-1.5 px-3 py-2 rounded-sm text-[11px] uppercase tracking-widest font-semibold transition-colors"
          style={active === key ? { background: "var(--cyan)", color: "#0c1424" } : { color: "var(--text-dim)", border: "1px solid var(--border-2)" }}>
          <Icon className="w-3.5 h-3.5" /> {label}
          {count != null && count > 0 && (
            <span className="px-1.5 rounded-sm font-mono text-[10px] font-bold"
              style={active === key ? { background: "rgba(12,20,36,0.22)" } : { background: "var(--bg-2)", color: "var(--cyan)" }}>{count}</span>
          )}
        </Link>
      ))}
    </div>
  );
};

export default ProjectTabs;
